export const environment = {
    production: true,
    apiUrl: "",
    apiVersion: "1.0",
    groupName: "Klasse",
    groupsName: "",
    buildingName: "Schulhaus",
    buildingsName: "Schulhäuser",
    categories: "",
    children: "Kinder",
    firebase: {
        apiKey: "AIzaSyBkK9NZCOBQ8zy_RffdHi8IafwTjOAj0Ts",
        authDomain: "schule-vogelsang-92e6o9.firebaseapp.com",
        databaseURL: "https://schule-vogelsang-92e6o9-default-rtdb.firebaseio.com",
        projectId: "schule-vogelsang-92e6o9",
        storageBucket: "schule-vogelsang-92e6o9.appspot.com",
        messagingSenderId: "766025152048",
        appId: "1:766025152048:web:94116c07628e04347a5ff5",
        measurementId: "G-JEJWQV82H9"
    }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts